<template>
  <div class="member-area-tab-cover-config-component">
    <div class="mb-2">
      <h5 class="text-semibold">
        Imagens de capa
      </h5>
      <small class="text-dark-40 fs-12">
        Defina como será a capa da tela inicial na sua área de membros.
      </small>
    </div>

    <h5 class="text-semibold mb-1">
      Capa versão desktop
    </h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-switch
          id="cover-view-type-club"
          v-model="isVideoCover"
          class="mb-4"
          label="Vídeo"
        />
        <div v-if="!isVideoCover">
          <snow-input-file
            isImage
            backgroundColor="bg-1"
            v-model="form.cover"
            id="cover"
            title="Capa horizontal"
            dimensions="2160x740"
          />
        </div>
        <div class="video-container" v-else>
          <snow-input
            v-model="form.link_video"
            id="link_video"
            label="URL do vídeo"
          />
          <small class="text-dark-40 fs-12">
            Seus arquivos precisam estar hospedados em um serviço, como YouTube,
            Vimeo, Pandavideo, etc.
          </small>
        </div>
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-cover-desktop.svg" />
      </div>
    </div>

    <h5 class="text-semibold mt-7">
      Capa versão mobile
    </h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          isImage
          backgroundColor="bg-1"
          v-model="form.cover_mobile"
          id="image-mobile-cover"
          title="Capa Mobile"
          dimensions="560x740"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-cover-mobile.svg" />
      </div>
    </div>

    <h5 class="text-semibold mt-7">
      Capa versão quadrada
    </h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          isImage
          backgroundColor="bg-1"
          v-model="form.cover_zeuspay_club"
          id="image-mobile-cover"
          title="Capa quadrada"
          dimensions="320x320px"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-cover-zeus-club.svg" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isVideoCover: {
      get() {
        return this.form.cover_view_type === "video";
      },
      set(val) {
        this.form.cover_view_type = val ? "video" : "image";
      }
    }
  }
};
</script>
<style scoped lang="scss">
.member-area-tab-cover-config-component {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: 992px) {
    .video-container {
      max-width: 80%;
    }
  }
}
</style>
